<template>
  <div>
    <a-card>
      <a-tabs class="package" @change="onTabsChange">
        <a-tab-pane v-for="(tab, index) in tabs" :key="index">
          <span slot="tab"> <a-icon :type="tab.platform === 'ios' ? 'apple' : tab.platform" theme="filled" /> {{ tab.name }} </span>
          <a-form-model layout="inline" :form="filterForm" :model="filterForm">
            <a-form-model-item label="环境">
              <a-radio-group v-model="filterForm.environment" default-value="1" button-style="solid" @change="handleChange">
                <a-radio-button :value="null"> 全部 </a-radio-button>
                <a-radio-button v-for="(env, envIndex) in envs" :key="envIndex" :value="env.value"> {{ env.label }} </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="版本">
              <a-select v-model="filterForm.version" style="width: 120px" allow-clear @change="handleChange">
                <a-select-option v-for="version in tab.versions" :key="version" :value="version">{{ version }} </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="构建版本">
              <a-input v-model="filterForm.build_version" @change="handleChange" />
            </a-form-model-item>
          </a-form-model>
          <a-table :pagination="pagination" :columns="columns" :loading="loading" size="middle" :data-source="tableData" row-key="release_id" class="package-table" @change="handleTableChange">
            <span slot="showQrCode" slot-scope="text, record">
              <a-icon type="qrcode" class="qr-code-button" @click="onShowQrCode(record)" />
            </span>
            <span slot="releaseId" slot-scope="text, record">
              <a class="a-download" :href="record.download_url" target="_blank">{{ record.release_id }}</a>
            </span>
            <span slot="tags" slot-scope="text, record">
              <a-tag v-for="(tag, i) in record.tags" :key="i" color="cyan">{{ packageTags[tag].label }}</a-tag>
            </span>
            <span slot="action" slot-scope="text, record">
              <a class="ant-dropdown-link" :href="record.download_url" target="_blank"> 查看 </a>
              <a-divider type="vertical" />
              <a-dropdown placement="bottomCenter">
                <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a class="ant-dropdown-link" @click="onEdit(record)">编辑标签</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a class="ant-dropdown-link" @click="onPush(record)">推送消息</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
            <span slot="expandedRowRender" slot-scope="record" style="white-space: pre-wrap; margin: 0">
              <h4>更新日志:</h4>
              <span>{{ record.changelog }}</span>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <package-modal :is-show="editVisible" :package-id="packageId" :tags="tags" @close="close" />
    <package-push-modal :is-show="pushVisible" :package-id="packageId" :changelog="changelog" @close="close" />
    <qr-code-modal :is-show="modalVisible" :content="content" @close="close" />
  </div>
</template>

<script>
import QrCodeModal from '@/pages/tools/components/QrCodeModal';
import PackageModal from '@/pages/tools/components/PackageModal';
import PackagePushModal from '@/pages/tools/components/PackagePushModal';
import { toolsPackageSetting, toolsPackageList } from '@/api/tools/package';
import { packageTags } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    align: 'center',
    width: 80
  },
  {
    title: '环境',
    dataIndex: 'environment',
    key: 'environment',
    align: 'center',
    width: 140
  },
  {
    title: '版本',
    dataIndex: 'version',
    key: 'version',
    align: 'center',
    width: 140
  },
  {
    title: '构建版本',
    dataIndex: 'build_version',
    key: 'build_version',
    align: 'center',
    width: 140
  },
  // {
  //   title: '更新日志',
  //   key: 'changelog',
  //   ellipsis: true,
  //   dataIndex: 'changelog'
  // },
  {
    title: '标签',
    key: 'tags',
    // align: 'center',
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '更新时间',
    key: 'created_time',
    align: 'center',
    width: 180,
    dataIndex: 'created_time'
  },
  {
    title: '二维码',
    key: 'url',
    dataIndex: 'url',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'showQrCode' }
  },
  {
    title: '操作',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: {
    QrCodeModal,
    PackageModal,
    PackagePushModal
  },
  data() {
    return {
      filterForm: {
        name: null,
        platform: null,
        version: null,
        build_version: null,
        environment: null,
        page_size: 10,
        page_number: 1
      },
      loading: false,
      envs: [],
      tabs: [],
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      content: {},
      modalVisible: false,
      editVisible: false,
      pushVisible: false,
      packageId: null,
      tags: [],
      changelog: null,
      tableData: [],
      packageTags,
      columns
    };
  },
  created() {
    this.getPackageSetting();
  },
  methods: {
    // 点击查看二维码
    onShowQrCode(record) {
      this.content = record;
      this.modalVisible = true;
    },

    handleChange() {
      this.filterForm.page_number = 1;
      this.getPackageList();
    },

    onTabsChange(key) {
      this.filterForm.platform = this.tabs[key].platform;
      this.filterForm.name = this.tabs[key].name;
      this.handleChange();
    },

    toggle() {
      this.expand = !this.expand;
    },

    getPackageSetting() {
      toolsPackageSetting({}).then(response => {
        this.envs = response.data.envs;
        this.tabs = response.data.tabs;
        if (this.tabs.length > 0) {
          this.filterForm.platform = this.tabs[0].platform;
          this.filterForm.name = this.tabs[0].name;
        }
        this.getPackageList();
      });
    },

    // 获取App安装包列表
    getPackageList() {
      this.loading = true;
      toolsPackageList(this.filterForm)
        .then(response => {
          this.loading = false;
          this.tableData = response.data.package_list;
          this.pagination.total = response.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getPackageList();
    },

    onEdit(record) {
      this.editVisible = true;
      this.tags = record.tags;
      this.packageId = record.id;
    },

    onPush(record) {
      this.pushVisible = true;
      this.changelog = record.changelog;
      this.packageId = record.id;
    },

    // 关闭弹窗
    close(type = 'close') {
      this.modalVisible = false;
      this.editVisible = false;
      this.pushVisible = false;
      this.tags = [];
      this.changelog = null;
      this.packageId = null;
      if (type === 'close') {
        this.getPackageList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.package-table {
  margin-top: 16px;
}
.qr-code-button {
  font-size: 28px;
}
.a-download {
  color: rgba(0, 0, 0, 0.65);
}
</style>
